/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_ItalicInputs */



/**
* | output |
* | --- |
* | "Italic" |
*
* @param {Transcript_Export_ItalicInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_italic = /** @type {((inputs?: Transcript_Export_ItalicInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_ItalicInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Italic")
	if (locale === "de") return /** @type {LocalizedString} */ ("Italic")
	if (locale === "it") return /** @type {LocalizedString} */ ("Italic")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Italic")
	if (locale === "es") return /** @type {LocalizedString} */ ("Italic")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Italic")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Italic")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Italic")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Italic")
	return /** @type {LocalizedString} */ ("Italic")
});